import Obj from "./obj";

let objs = [];
let color = '#2A2145'
let maxR;
let nt = 0;
let nR = 0;
let nTheta = 1000;
let observer = true;
let p5_aux 
export function isObserver(value){
  observer = value;
  if(!observer){
    p5_aux?.noLoop();
  }else{
    p5_aux?.loop();
  }
}

export function setup(p5, canvasParentRef) {
  p5.createCanvas(p5.windowWidth, p5.windowHeight).parent(canvasParentRef);
  p5.angleMode(p5.DEGREES);
  p5.noStroke();
  p5_aux= p5
  maxR = p5.max(p5.width, p5.height) * 0.45;
  p5.background(color);
}

export function draw(p5) {
  p5.background(color);

  let R = p5.map(p5.noise(nt * 0.01, nR), 0, 1, 0, maxR);
  let t = p5.map(p5.noise(nt * 0.001, nTheta), 0, 1, -360, 360);
  let x = R * p5.cos(t) + p5.width / 2;
  let y = R * p5.sin(t) + p5.height / 2;
  objs.push(new Obj(x, y, p5));
  

  if (p5.mouseIsPressed) {
    objs.push(new Obj(p5.mouseX, p5.mouseY, p5));
  }

  for (let i = 0; i < objs.length; i++) {
    objs[i].move();
    objs[i].display();
  }

  for (let j = objs.length - 1; j >= 0; j--) {
    
    if (objs[j].isFinished()) {
      objs.splice(j, 1);
    }
  }

  // t++;
  nt++;
}

export function windowResized(p5) {


    p5.resizeCanvas(p5.windowWidth, p5.windowHeight);
    p5.background(color);
  


}
